import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon TrashIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const TrashIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <path d="M22.5 4h-4.8l-1.1-2.6A2.4 2.4 0 0014.5 0h-5a2.4 2.4 0 00-2 1.4L6.2 4H1.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H3v14.9A2.9 2.9 0 005.5 24h13a3 3 0 002.5-3.2V6h1.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zM9.3 2.2a.5.5 0 01.2-.2h5a.5.5 0 01.3.2l.7 1.8h-7zM19 20.8a1.4 1.4 0 01-.5 1.2h-13a1.4 1.4 0 01-.5-1.2V6h14zM10.5 9.5v9a.5.5 0 01-.5.5H9a.5.5 0 01-.5-.5v-9A.5.5 0 019 9h1a.5.5 0 01.5.5zm4.8 0v9a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5h1a.5.5 0 01.5.5z" />
    </Icon>
  )
}
export default TrashIcon
